import React from 'react';
import { Form } from 'antd';
import { Moment } from 'moment';
import { DatePicker } from 'components';
import { DatePickerProps } from 'components/date-time-pickers/date-picker/date-picker';

interface Props {
	name?: string;
	onFilterChange: (value: Moment) => void;
	datePickerProps?: Omit<DatePickerProps, 'value' | 'onChange' | 'picker'>;
}
export const FilterContentDate = ({ name, onFilterChange, datePickerProps }: Props) => {
	return (
		<Form.Item name={name}>
			<DatePicker onChange={onFilterChange} {...datePickerProps} />
		</Form.Item>
	);
};
